/* global Blockly */
import React from "react";
import { textscannerIcon } from "./index";

function defineBlock(context) {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField("get ")
                .appendField(
                    new Blockly.FieldDropdownSearch(
                        [
                            ["source", "source"],
                            ["base64 string", "base64"],
                        ],
                        undefined,
                        undefined,
                    ),
                    "METHOD",
                );
            this.appendDummyInput("VALUE")
                .appendField(" of image in ")
                .appendField(
                    new Blockly.FieldImage(textscannerIcon, 30, 30, "text scanner icon", null),
                    "textScannerIcon",
                )
                .appendField(
                    new Blockly.FieldWidgetsDropdown(
                        context,
                        "textscanner",
                        undefined,
                        "- select -",
                    ),
                    "ID",
                );

            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, ["String"]);
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip("Get the source (URL or base64 string) for scanner widget");
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#scanners");
        },

        onchange: function () {
            if (this.getField("textScannerIcon")?.imageElement_)
                this.getField("textScannerIcon").setTooltip("Scanner control");
        },
    };
}

function defineGenerators() {
    return {
        JavaScript: function (block) {
            let id = block.getFieldValue("ID");
            let methodSelector = block.getFieldValue("METHOD");
            let method = methodSelector == "base64" ? "getSourceBase64" : "getSource";
            let code = `Snap.widgets.scanner.${method}("${id}")`;
            return [code, Blockly.JavaScript.ORDER_NONE];
        },
    };
}

const GetTextScannerImageSource = function (props) {
    const name = "snap_get_textscanner_image_source";
    GetTextScannerImageSource.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {props.widget?.id ? <field name="ID">{props.widget.id}</field> : null}
        </block>
    );
};

export default GetTextScannerImageSource;
